<!-- <div style="background:rgba(11,16,38,.9); position: fixed; left: 0; top: 0; width: 100%; height: 100%; z-index: 999999; " >
    <div id="workmateLoader" class="lottie" data-animation-path="animation/" data-anim-loop="true" data-name="ninja" ></div>
 </div> -->

 <div class="mainLoader" *ngIf="isWebApp">
    <div class="innerLoader">
        <img src="assets/img/Workmate_Mobile_white.gif" alt="">
    </div>
</div>

<div class="mainLoader" *ngIf="isWebApp == false"  [intouchloader2]="true">
    <div class="innerLoader">
    </div>
</div>
